import { Style, StyleType } from "gc-types";
import dayjs from "dayjs";
import { CollectionDesignation } from "../common/interfaces";

export const isInternetExplorer = () => {
  // @ts-ignore
  return !window.ActiveXObject && "ActiveXObject" in window;
};

export const catalogueIncludesPath = (pathname: string): boolean => {
  return window.location.pathname.includes(pathname);
};

export const isClearanceCatalogue = (): boolean => {
  return catalogueIncludesPath("/clearance");
};

export const isBeautyAndWellnessCatalogue = (): boolean => {
  return catalogueIncludesPath("/beauty-and-wellness");
};

export const getRenderAsSubscription = (
  { designations_include_subscription, designations_include_rental, record_type }: Style,
  collectionDesignation: CollectionDesignation
) => {
  const isRentalStyle = record_type === StyleType.RentalUnit;
  if (!isRentalStyle) {
    return false;
  }

  if (designations_include_rental && designations_include_subscription) {
    return collectionDesignation === CollectionDesignation.Subscription;
  }
  return designations_include_subscription;
};

export const getDaysCount = (startDateStr: string | undefined, endDateStr: string | undefined): number | undefined => {
  if (startDateStr && endDateStr) {
    const startDate = dayjs(startDateStr);
    const endDate = dayjs(endDateStr);

    const validDates = startDate.isValid() && endDate.isValid();
    const isSequential = startDate.isBefore(endDate);

    if (validDates && isSequential) {
      return endDate.diff(startDate, "day") + 1;
    }
    return undefined;
  }
  return undefined;
};
